import axios from 'axios'
import urlGenerator from './url-generator'
import { property, get } from 'lodash'
import createRequestConfig from './create-request-config'

const fetchUser = ({
    name,
    description,
    facilitatorId,
    date,
    locationId,
    hourId,
    durationId,
    minCapacity,
    maxCapacity,
    credits,
    dimensions,
    gradeLevels,
    requirements,
}) => {
    const course = {
        name,
        description,
        facilitatorId,
        date,
        locationId,
        hourId,
        durationId,
        minCapacity,
        maxCapacity,
        credits,
        dimensions,
        gradeLevels,
        requirements,
    }
    return axios.post(urlGenerator.courses(), course, createRequestConfig()).then(property('data'))
}

export default fetchUser